var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 110 16A8 8 0 018 0zm.467 3.157L7.042 4.32c-.066.053-.066.14 0 .195l1.425 1.162c.066.054.12.029.12-.057v-.617c0-.085.068-.143.151-.125a3.23 3.23 0 012.535 3.147 3.228 3.228 0 01-6.455 0 .386.386 0 00-.772 0 4.001 4.001 0 004 3.993c2.205 0 4-1.792 4-3.993a4 4 0 00-3.307-3.932.188.188 0 01-.152-.178v-.701c0-.085-.054-.11-.12-.057z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

export default SvgReset;